import BatchSetAttentionModal from './batch-set-attention-modal.vue'
export default BatchSetAttentionModal
